import { NgModule } from "@angular/core";
import { CommonModule, NgClass, NgStyle } from "@angular/common";
import {
  HardBtnComponent,
  HardFormModule,
  HardTranslatePipe,
} from "@hardcode-kz/ui";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbPopover, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { UIFilterComponent } from "../ui-filter/ui-filter.component";
import { UIFilterDialogComponent } from "../ui-filter-dialog/ui-filter-dialog.component";
import { MatBadge } from "@angular/material/badge";
import { EquipmentSelectionWithFilterComponent } from "@app/shared/components/equipment-selection-with-filter/equipment-selection-with-filter.component";

@NgModule({
  declarations: [
    UIFilterComponent,
    UIFilterDialogComponent,
    EquipmentSelectionWithFilterComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgClass,
    HardBtnComponent,
    FormsModule,
    NgbPopover,
    NgStyle,
    NgbPopover,
    HardFormModule,
    MatBadge,
    HardTranslatePipe,
    NgbTooltip,
  ],
  exports: [
    UIFilterComponent,
    UIFilterDialogComponent,
    EquipmentSelectionWithFilterComponent,
  ],
})
export class UIFormModule {}
